
  <div>
    <h2 style="font-size: 15px; color: #9b7544">  Thank you for registering for updates. You will be hearing from us soon! </h2>
    <br><br>  <h2 style="font-size: 15px; color: #9b7544">To Continue Shopping for Your Beloved Pet  </h2>
   <a style="font-size: 15px; color: #9b7544">
      <u (click)="closeDialog()"> Click Here </u>
    </a>
    </div>
